import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { UNITY_EDITOR_URL } from './unityEditorMode';
import { IUnityEditorState } from './UnityEditorTransport';

const STATUS_TEXT: Record<IUnityEditorState['status'], { label: string; color: string }> = {
    connecting:   { label: 'Kapcsolódás…',    color: '#b58900' },
    connected:    { label: 'Kapcsolódva az Editorhoz', color: '#2e7d32' },
    disconnected: { label: 'Nincs kapcsolat', color: '#c62828' },
};

const UnityEditorStatusPanel: React.FC<{ state: IUnityEditorState }> = ({ state }) => {
    const status = STATUS_TEXT[state.status];

    return (
        <Box sx={{
            width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 1, p: 3, textAlign: 'center',
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: status.color }} />
                <Typography variant="subtitle1">{status.label}</Typography>
            </Box>

            <Typography variant="caption" color="text.secondary">
                Unity editor mode — a modell az Editor Game view-jában látszik, nem itt.
                <br />{UNITY_EDITOR_URL}
                {state.generation > 0 && ` · újrakapcsolódás #${state.generation}`}
            </Typography>

            {state.status !== 'connected' && (
                <Typography variant="caption" color="text.secondary" sx={{ maxWidth: 380 }}>
                    Nyisd meg a Unity projektet és lépj Play módba. A kapcsolat magától helyreáll —
                    C#-újrafordítás után is.
                </Typography>
            )}

            {state.lastError && (
                <Typography variant="caption" color="error" sx={{ maxWidth: 380, mt: 1 }}>
                    {state.lastError}
                </Typography>
            )}
        </Box>
    );
};

export default UnityEditorStatusPanel;
